import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-setting-adjustment',
  templateUrl: './setting-adjustment.component.html',
  styleUrls: ['./setting-adjustment.component.scss']
})
export class SettingAdjustmentComponent implements AfterViewInit {
  public company_uuid;
  public type;
  public data: any = {};
  public banks: any = [];
  public games: any = [];
  @ViewChild('f') f : NgForm
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private route: ActivatedRoute, private cdr : ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();
    const type: Observable<string> = this.route.params.pipe(map(p => p['type']));
    
    type.subscribe(val => {
      if (val && val != this.type) {
        this.type = val;
        this.data = {};
      } else if (!val) {
        this.type = 'game';
      }

      this.init();

    })
    
  }

  ngAfterViewInit(): void {
  }

  async initTable() {
    const setting = 
        { post: {url: "/admin/setting/adjustment/get", data: {uuid: this.company_uuid, type: this.type, page_nat: true, page: {per_page: 20}}},
          disabled_pagenat: false,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Date', type: 'timestamp', key: 'timestamp', filter: "string"}, 
            {label: this.capitalize(this.type) + ' Debit', type: 'price', key: 'debit'}, 
            {label: this.capitalize(this.type) + ' Credit', type: 'price', key: 'credit'}, 
            {label: this.capitalize(this.type) + ' Balance', type: 'price', key: 'balance'}, 
            {label: 'Remark', type: 'string', key: 'remark'}
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();
  }

  capitalize(s)
  {
      return s[0].toUpperCase() + s.slice(1);
  }

  async init() {
    if(this.type == 'game') {
      this.games = await this.http.post("/admin/setting/game/get", {status: 1});
      this.data.game = this.games[0]['id']
    } else {
      this.banks = await this.http.post("/admin/setting/bank/get", {status: 1});
      this.data.bank = this.banks[0]['id']
    }
    this.initTable();
  }

  async submit() {
    await this.http.post("/admin/setting/adjustment/update", this.data);
    await this.f.resetForm();
    await this.init()
  }

}